import logo from "./ic.png";
import s1 from "./service1.jpg";
import s2 from "./s2.jpg";
import s3 from "./s3.jpg";
import s4 from "./s4.jpg";
import s5 from "./s5.jpg";
import s6 from "./s6.jpg";
import qr from "./qr.jpeg";
import mlogo from "./mlogo.jpeg";
import s7 from "./s7.jpg";
import s8 from "./s8.jpg";
import mprihanan from "./mprihanan.png";
const backend_url="https://api.vahansolution.co.in" 
// const backend_url="http://localhost:5200" 

export { 
  logo, mprihanan,qr,
  s1, s2, s3, backend_url,s4, mlogo,s5, s6, s7, s8,  
};